import debounce from "lodash.debounce";
import React, { useCallback, useState } from "react";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { gstVerificationRequest } from "../../store/actions";

export default function SellerUserTable({
  columns,
  rows,
  setRows,
  OLDDataList,
  setOLDDataList,
  showEntityCode,
  onChangesAuctionCenterId,
  disabled,
}) {
  const [checkedColumns, setCheckedColumns] = useState({});
  const [oldColumnValues, setOldColumnValues] = useState({});
  const dispatch = useDispatch();

  const filterdColumns = showEntityCode ? columns : columns.filter((item) => item.name!=="entityCode")

  // Handle input change for a specific row and field
  const handleInputChange = (event, rowId, fieldName, newValue, stateCode) => {
    // Only update the specific field (like 'gstNo') and ensure `stateCode` isn't repeatedly added

    const newStateCode = stateCode || ''
    const updatedValue = fieldName === "gstNo" ? `${newStateCode}${newValue}` : newValue
      
    if (checkedColumns[fieldName]) {
      // If the column is checked, update all cells in the column with the new value
      setRows((prevData) =>
        prevData?.map((row) => ({ ...row, [fieldName]: updatedValue }))
      );
    } else {
      // Otherwise, update only the specific cell
      setRows((prevData) =>
        prevData?.map((row) =>
          row.auctionCenterId === rowId
            ? { ...row, [fieldName]: updatedValue }
            : row
        )
      );
    }

    // Always update the OLDDataList for the specific field (like 'gstNo')
    setOLDDataList((prevData) =>
      prevData?.map((row, idx) =>
        idx === rowId ? { ...row, [fieldName]: updatedValue } : row
      )
    );
  };


  // Debounced API call for GST number verification
  const debouncedApiCall = useCallback(
    debounce((stateId, key, value) => {
      console.log(value);
      // dispatch(gstVerificationRequest(value)); // Un-comment to enable API call
    }, 2000),
    [] // Dependency array to ensure the function is only created once
  );

  // Temporary function to handle auction center data changes
  const tempAuctionCenterDataChange = (
    key,
    value,
    stateId,
    fromMultiple,
    debouncedApiCall
  ) => {
    // Handle changes based on stateId
    const updatedRows = rows.map((data) => {
      // Only update the row where the stateId matches
      if (data.stateId === stateId) {
        return {
          ...data, // Spread to ensure other fields remain unchanged
          [key]: value, // Update the specific field (key)
        };
      }
      return data;
    });

    // Update state with the new rows
    setRows(updatedRows);

    // If key is "gstNo", trigger the debounced API call to update the GST number
    if (key === "gstNo") {
      console.log(stateId, key, value, "stateId, key, value");
      debouncedApiCall(stateId, key, value); // Call the debounced API function
    }
  };
  

  // Handle checkbox changes (update the checked column state)
  const handleCheckboxChange = (isChecked, fieldName) => {
    setCheckedColumns((prev) => ({ ...prev, [fieldName]: isChecked }));

    if (isChecked) {
      // Save the current values of the column and mark them as disabled
      const currentColumnValues = rows.map((row) => row[fieldName]);
      setOldColumnValues((prev) => ({
        ...prev,
        [fieldName]: currentColumnValues,
      }));

      // Set all cells in the column to the first cell's value
      const firstCellValue = rows[0][fieldName];
      setRows((prevData) =>
        prevData?.map((row) => ({ ...row, [fieldName]: firstCellValue }))
      );
    } else {
      // Revert only the values in the column that were changed when the column was checked
      setRows((prevData) =>
        prevData?.map((row, idx) => {
          if (checkedColumns[fieldName] && idx !== 0) {
            return { ...row, [fieldName]: oldColumnValues[fieldName][idx] };
          }
          return row;
        })
      );
    }
  };

  return (
    <div className="col-8">
      <div className="TableBox w-100">
        {onChangesAuctionCenterId?.length > 0 && (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                {filterdColumns?.map((col, colIndex) => (
                  <th
                    key={colIndex}
                    className={col.mandatory ? "mandatory-field" : ""}
                  >
                    {col.title}
                    {col.checkbox && (
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          handleCheckboxChange(e.target.checked, col.name)
                        }
                        disabled={disabled}
                      />
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows
                ?.filter((row) =>
                  onChangesAuctionCenterId?.includes(row.auctionCenterName)
                )
                ?.map((row, rowIndex) => ({
                  ...row,
                  srNo: rowIndex + 1, // Automatically set serial number
                }))
                .map((item, rowIndex) => (
                  <tr key={rowIndex}>
                    {filterdColumns?.map((col, colIndex) => (
                      <td key={colIndex}>
                        {/* For serial number (srNo), display it directly */}
                        {col.name === "srNo" ? (
                          item.srNo
                        ) : col.noneditable ? (
                          col.fixValue ? (
                            col.fixedColumnValue
                          ) : (
                            item[col.name]
                          )
                        ) : col.dropdown ? (
                          <select
                            value={item[col.name] ?? ""}
                            onChange={(event) => {
                              const newValue = event.target.value
                              handleInputChange(
                                event,
                                item.auctionCenterId,
                                col.name,
                                newValue
                              )
                            }
                            }
                            disabled={
                              disabled
                                ? disabled
                                : checkedColumns[col.name] && rowIndex !== 0
                            }
                          >
                            <option value={0}>Please Select</option>
                            {col?.options?.map((option, optIndex) => (
                              <option key={optIndex} value={option.value}>
                                {option.title}
                              </option>
                            ))}
                          </select>
                        ) : col.name === "gstNo" ? (
                          <input
                            type="text"
                            maxLength="15"
                            value={`${item[col.name] ?? ""}`}
                            onChange={(e) => {

                              const newValue = e.target.value.replace(item.stateCode, '').trim();
                              tempAuctionCenterDataChange(
                                "gstNo",
                                e.target.value,
                                item.stateId, // Pass the correct stateId here
                                false,
                                debouncedApiCall
                              );
                              handleInputChange(
                                e,
                                item.auctionCenterId,
                                col.name,
                                newValue,
                                item.stateCode
                              );
                            }}
                            disabled={disabled}
                          />
                        ) : col.name === "mobileNo" ? (
                          <input
                            type="text"
                            maxLength={col.maxLength}
                            value={item[col.name] ?? ""}
                            onChange={(event) => {
                              const newValue = event.target.value
                              handleInputChange(
                                event,
                                item.auctionCenterId,
                                col.name,
                                newValue
                              )
                            }}
                            disabled={
                              disabled
                                ? disabled
                                : checkedColumns[col.name] && rowIndex !== 0
                            }
                          />
                        ) : (
                          <input
                            type="text"
                            value={item[col.name] ?? ""}
                            onChange={(event) =>{
                              const newvalue = event.target.value
                              handleInputChange(
                                event,
                                item.auctionCenterId,
                                col.name,
                                newvalue
                              )
                            }
                             
                            }
                            disabled={
                              disabled
                                ? disabled
                                : checkedColumns[col.name] && rowIndex !== 0
                            }
                          />
                        )
                        }
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
}
